import BurgerIcon from 'assets/svg/burger-icon/burger-icon.svg'
import Category from 'common/components/Category'
import LanguageDropdown from 'common/components/LanguageDropdown'
import Popover from 'common/components/Popover'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import ThemeColorHelper from 'lib/theme-color-helper'
import { useTranslation } from 'react-i18next'
import StartSellingButton from 'services/Seller/components/StartSellingButton'
import styled from 'styled-components'

const Nav = styled.nav`
  background-color: ${theme.colors.grayLighter};
  border-bottom: 1px solid ${theme.colors.grayLight};
`

const Container = styled.div`
  height: 56px;
  width: ${theme.layout.containerWidth};
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const MenuMain = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  height: 18px;
  li {
    margin: 0 30px 0 0;
    position: relative;
    :last-child {
      margin: 0;
    }
  }
`

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.black};
  &:hover,
  &:focus {
    color: ${theme.colors.orange};
    > p {
      color: ${theme.colors.orange};
    }
  }
  > p {
    text-transform: Capitalize;
  }
`

const MenuAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  > * {
    display: flex;
    padding: 0 15px;
    :last-child {
      padding-right: 0;
    }
  }
`

const SelectLanguage = styled.div`
  height: 24px;
  color: ${theme.colors.black};
  display: flex;
  align-items: center;

  > div {
    width: 110px;
  }
`

function TopNav({
  onOpenOverlay,
  onCloseOverlay,
  show = true,
  lang,
}: {
  onOpenOverlay?: Function
  onCloseOverlay?: Function
  show?: boolean
  lang?: string
}): JSX.Element {
  const { i18n, t } = useTranslation('common')

  if (!show) return <></>

  return (
    <Nav>
      <Container data-testid="topnav-container">
        <MenuMain>
          <li>
            <Popover
              side="bottom"
              position="full"
              onOpenOverlay={onOpenOverlay}
              onCloseOverlay={onCloseOverlay}
              full
              content={<Category />}
            >
              <StyledLink>
                <BurgerIcon />
                <Typography type="rparagraph" marginLeft="10px">
                  {t('CATEGORY')}
                </Typography>
              </StyledLink>
            </Popover>
          </li>

          <li>
            <StyledLink href={`${WEB_DESKTOP_RALALI_URL}/blog`}>
              <Typography type="rparagraph">{t('BLOG')}</Typography>
            </StyledLink>
          </li>
        </MenuMain>

        <MenuAction>
          <StartSellingButton
            buttonColor={ThemeColorHelper('orange')}
            version="v2"
          />
          <SelectLanguage>
            <LanguageDropdown
              initialLang={
                lang || i18n.resolvedLanguage || i18n.language
              }
            />
          </SelectLanguage>
        </MenuAction>
      </Container>
    </Nav>
  )
}

export default TopNav
